"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketMessagePurpose = exports.MessageMethod = exports.MessageDirection = void 0;
var MessageDirection;
(function (MessageDirection) {
    MessageDirection["INBOUND"] = "inbound";
    MessageDirection["OUTBOUND"] = "outbound";
})(MessageDirection || (exports.MessageDirection = MessageDirection = {}));
var MessageMethod;
(function (MessageMethod) {
    MessageMethod["SMS"] = "sms";
    MessageMethod["EMAIL"] = "email";
})(MessageMethod || (exports.MessageMethod = MessageMethod = {}));
var TicketMessagePurpose;
(function (TicketMessagePurpose) {
    TicketMessagePurpose["PURCHASE_NOTIFICATION"] = "purchase_notification";
    TicketMessagePurpose["ASSIGNMENT_NOTIFICATION"] = "assignment_notification";
})(TicketMessagePurpose || (exports.TicketMessagePurpose = TicketMessagePurpose = {}));
